'use strict';

var tealiumEnable = require('int_tealium_sfra/tealiumEnable');

/**
 * PDP Video functionality
 */
export function pdpVideo() {
    const $videos = $('.pdp-video1 video, .pdp-video2 video');

    if (!$videos.length) {
        return;
    }

    $videos.each(function () {
        const videoElement = this;
        const $video = $(videoElement);
        const $source = $video.find('source');

        const updateVideoSource = () => {
            const dataSrc = $source.attr('data-src');
            if (dataSrc && !$source.attr('src')) {
                $source.attr('src', dataSrc);
                videoElement.load();
            }
        };

        if (videoElement.intersectionObserver) {
            videoElement.intersectionObserver.disconnect();
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    updateVideoSource();
                    if (videoElement.autoplay) {
                        videoElement.play();
                    }
                } else {
                    videoElement.pause();
                }
            });
        }, {
            threshold: 0.05
        });

        videoElement.intersectionObserver = observer;
        observer.observe(videoElement);
        $video.off('.pdpVideo');
    });

    /**
     * Video click play/pause
     */
    $videos.off('play.pdpVideo pause.pdpVideo ended.pdpVideo click.pdpVideo')
    .on('play.pdpVideo', function () {
        $(this).closest('.swiper-slide').find('.pdpvideo-playPause').addClass('vidplay');
    })

    .on('pause.pdpVideo ended.pdpVideo', function () {
        $(this).closest('.swiper-slide').find('.pdpvideo-playPause').removeClass('vidplay');
    })

    .on('click.pdpVideo', function () {
        const $playPauseBtn = $(this).closest('.swiper-slide').find('.pdpvideo-playPause');
        const videoIndex = $(this).closest('.swiper-slide').data('video-index');
        const videoUrl = $(this).closest('.swiper-slide').find('source').data('src');

        if (this.paused) {
            this.play();
            tealiumEnable.getAnalyticsData('trackPdpVideosClick', 'pdp-video_play', videoIndex, videoUrl);
        } else {
            this.pause();
            tealiumEnable.getAnalyticsData('trackPdpVideosClick', 'pdp-video_pause', videoIndex, videoUrl);
        }
        $playPauseBtn.removeClass('vidplay');
    });

    /**
     * Play/Pause button click
     */
    $('.pdpvideo-playPause').off('click.pdpVideo').on('click.pdpVideo', function (e) {
        e.preventDefault();

        const video = $(this)
            .closest('.swiper-slide')
            .find('video')[0];
        const $playPauseBtn = $(this)
            .closest('.pdpvideo-playPause');

        if (!video) {
            return;
        }

        const videoIndex = $(this).closest('.swiper-slide').data('video-index');
        const videoUrl = $(this).closest('.swiper-slide').find('source').data('src');

        if (video.paused) {
            video.play();
            $playPauseBtn.addClass('vidplay');
            tealiumEnable.getAnalyticsData('trackPdpVideosClick', 'pdp-video_play', videoIndex, videoUrl);
        } else {
            video.pause();
            $playPauseBtn.removeClass('vidplay');
            tealiumEnable.getAnalyticsData('trackPdpVideosClick', 'pdp-video_pause', videoIndex, videoUrl);
        }
    });
}

$(document).ready(function () {
    pdpVideo();
});

export default {
    pdpVideo
};
